import {
  FormHelperText,
  CheckboxProps,
  Checkbox,
  FormControlLabel,
  FormGroup,
} from '@mui/material';
import { useField } from 'formik';
import React, { ReactNode, useRef } from 'react';
import { CheckedIcon, DisabledCheckedIcon, DisabledUncheckedIcon, UncheckedIcon } from '../../assets/SvgIcons';

export const MFCheckbox = function ({
  label,
  name,
  onChange,
  checked,
  sx,
  ...props
}: CheckboxProps & { label: string | JSX.Element; name: string }): JSX.Element {
  const [field, meta] = useField(name);
  const inputRef = useRef<HTMLInputElement>(null);
  checked = checked || field.value;
  onChange = onChange || field.onChange;
  const errorText = meta.error && meta.touched ? meta.error : '';
  const errorId = `${name}-checkbox-error`;
  return (
    <FormGroup>
      <FormControlLabel
        control={
          <Checkbox
            checkedIcon={props?.disabled ? <DisabledCheckedIcon /> : <CheckedIcon />}
            icon={props?.disabled ? <DisabledUncheckedIcon /> : <UncheckedIcon />}
            {...field}
            {...props}
            checked={checked}
            onChange={onChange}
            inputRef={inputRef}
            onKeyDown={(e: React.KeyboardEvent) => {
              if (e.key === 'Enter') {
                e.preventDefault();
                // Trigger native click so the real change pipeline runs;
                // this ensures consistent behaviour for keyboard and AT users.
                inputRef.current?.click();
              }
            }}
            inputProps={{
              'aria-invalid': !!errorText || undefined,
              'aria-describedby': errorText ? errorId : undefined,
            }}
          />}
        name={name}
        label={label}
        sx={{
          '& .Mui-disabled': {
            cursor: !props.disabled ? 'pointer' : 'not-allowed !important',
            pointerEvents: 'all',
          },
          ...sx,
        }}
        componentsProps={{ typography: { variant: 'body_500' } }}
      />
      {errorText && (
        <FormHelperText error sx={{ marginLeft: 'unset' }} id={errorId} role="alert" aria-live="polite">
          {errorText}
        </FormHelperText>
      )}
    </FormGroup>
  );
};

export default MFCheckbox;
